/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { Component, OnInit, NgZone, AfterViewInit, AfterContentChecked, AfterViewChecked, Inject, LOCALE_ID, OnDestroy, ElementRef } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { SettingsService } from './services/settings.service';
import { QueryParamsService } from './services/http/queryParams.service';
import { DeployParams } from './deployParams';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from './services/util/utility.service';
import { MessagingService } from './services/messaging.service';
import { TicketService } from './services/ticket.service';

import { MessagingProviderService } from './services/providers/messaging.provider.service';
import { Subscription } from 'rxjs';
import { ViewConfigurations } from './models/util/viewConfigurations';
import { LocaleHelper } from 'src/locale/LocaleHelper';
import { StorageService } from './services/util/storage.service';
import { PlatformHeadrId, SiteViewConfiguration } from './models/enums';
import { SettingsProviderService } from './services/providers/settings.provider.service';
import { EventsService } from './services/events.service';
import { UserService } from './services/user.service';
import { SignalRService } from './services/signal-r.service';
import { environment } from 'src/environments/environment';

declare let jQuery: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})

export class AppComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  title = 'Admiral';
  documentHeight = 0;
  documentWidth = 0;
  isStagingOrProd = false;
  pageTypeParam: string;

  rightContent;
  scrollTop = 0;

  isMobileView: boolean;

  windowHeight: number;
  parentWindowHeight: number;
  bottomElContent: any;
  ticketDetailWrap: any;
  notificationDialogWrap: any;
  ticketMainWrap: any;
  ticketDetailWrapNotificationDialogWrap: any;
  platformHeaderHeight = 0;
  bodyScrollTop = 0;
  isMaintenanceBreak: boolean;

  heightFromTop = 32;
  heightFromBottom = 32;

  topMenuWrapHeight = 0;

  //#region  for local login
  isLocalDeploy = environment.localDeploy;
  isUserLoggedIn = false;
  localUserId: string;
  loggedUserId;
  //#endregion for local login

  private language: string;
  private widgetLanguage: string;


  viewConfigurations = ViewConfigurations;
  private subscription: Subscription = new Subscription();

  platformWinWidth1600 = 1508;

  betRadarClientId = '92628c1eaee83871af5e17444ec08c99';

  hideTitketMenuBar = true;

  constructor(
    private messagingService: MessagingService,
    private messagingProvService: MessagingProviderService,
    public signalRService: SignalRService,
    private http: HttpClient,
    private queryParams: QueryParamsService,
    private ngZone: NgZone,
    private settingService: SettingsService,
    private utilityService: UtilityService,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private elementRef: ElementRef,
    private ticketService: TicketService,
    private eventsService: EventsService,
    private router: Router,
    private settingsProvider: SettingsProviderService,
    private userService: UserService) {
    // console.log('locale', locale);
    this.isMobileView = utilityService.mobileView;
    this.platformWinWidth1600 = this.viewConfigurations.useMobileViewWithTopMenu ? 1150 : 1200;
    this.language = this.storageService.language;
    // const iframe = window.parent.document.getElementById('sportIframe') as HTMLIFrameElement;
    // let tail = 'v=' + Math.round(Math.random() * 10000);
    // if (iframe) {
    //   const prefix = iframe.src.includes('?') ? '&' : '?';
    //   tail = prefix + tail;
    //   if (!iframe.src.includes('v=')) {
    //     iframe.src += tail;
    //     iframe.contentWindow.location.reload();
    //   }
    // }
    this.settingsProvider.getVersion().subscribe(version => {
      if (version.version) {
        if (version.version !== environment.productVersion) {
          console.log('VERSION DIFFERENT');
          console.log(version.version + ' - ' + environment.productVersion);
          this.reloadFrame();
          // window.parent.document.getElementById('sportIframe').contentWindow.location.reload();
        } else {
          console.log('VERSION SAME');
        }
      }
    });

    setTimeout(() => {
      this.hideTitketMenuBar = this.router.url.includes('account');
      // console.log('useMobileViewWithTopMenu', this.viewConfigurations.useMobileViewWithTopMenu);
      // console.log('hideTitketMenuBar', this.hideTitketMenuBar);
    }, 300);

    if (environment.localDeploy) {
      this.userService.userLoggedInOut$.subscribe(x => {
        this.isUserLoggedIn = x;
        if (true) {
          this.loggedUserId = +this.userService.user.userName;
        }
      });
    }
  }

  ngOnInit() {
    this.isMaintenanceBreak = environment.isMaintinanceBreak;
    this.widgetLanguage = LocaleHelper.languageForBetradar[this.language];
    this.loadWidgetScript();
    this.loggedUserId = this.userService.user.userName;


    // commneted because notifications are not redy for deploy
    // this.messagingService.requestPermission().subscribe();
    // this.messagingService.receiveMessage();


    // this.signalRService.startConnection();
    // this.signalRService.addTransferChartDataListener();
    // this.startHttpRequest();

    // const interval = setInterval(() => {
    //   this.rightContent = document.getElementsByClassName('right-content-wrap')[0];

    //   if (this.rightContent) {
    //     window.parent.document.addEventListener('scroll', () => {
    //       this.scrollTop = window.parent.scrollY;
    //       this.rightContent.style.marginTop = this.scrollTop + 'px';
    //       console.log(window.parent.scrollY);
    //       //   this.sendIframeSize();
    //     });
    //     clearInterval(interval);
    //   }

    // }, 100);

    // if (this.viewConfigurations.useMobileViewWithTopMenu) {
    //   document.getElementsByTagName('body')[0].classList.add('versionV2');
    // } else {
    //   document.getElementsByTagName('body')[0].classList.add('versionV1');
    // }

    document.getElementsByTagName('body')[0].classList.add('versionV1');

    window.parent.addEventListener('resize', () => {
      this.sendIframeSize();
      this.switchFromDesktopToMobileAndReverse();
    });
    this.isStagingOrProd = !environment.localDeploy ? true : false;

    // this.route.paramMap.subscribe(params => {
    //   this.pageTypeParam = params.get('pageType');
    // });

    window.parent.document.addEventListener('scroll', () => {
      this.scrollFunction();
    });

    // jQuery(window.parent).scroll(() => {
    //   console.log(1);
    //   this.scrollFunction();
    // });


    window.addEventListener('resize', () => {
      this.setTicketBarInitial();
      this.ticketDialogResize();
    });


    // if (!this.isMobileView ) {
    // }

    // // set empty background, background attachment and their background color for disable flickering (jumping) moving objects
    // if (this.isStagingOrProd && !this.viewConfigurations.useMobileViewWithTopMenu) {
    //   const parentBody = jQuery(window.parent.document.body);
    //   const parentBodyBackground = parentBody.css('background-color');
    //   const parentBodyImage = parentBody.css('background-image');
    //   parentBody.css('background', parentBodyImage === 'none' ? 'url()' : parentBodyImage);
    //   parentBody.css('background-attachment', 'fixed');
    //   parentBody.css('background-color', parentBodyBackground);
    // }

    this.setWindowHeight();
    const interval = setInterval(() => { this.setVariable(interval); }, 100);

    if (environment.localDeploy) {
      if (this.userService.user.userName) {
        this.isUserLoggedIn = true;
        this.loggedUserId = this.userService.user.userName.toString();
      } else {
        this.isUserLoggedIn = false;
      }
    }
  }

  loginOutLocal(login: boolean) {
    if (login) {
      this.userService.loginLocalUser(+this.localUserId);
    } else {
      this.userService.logout();
    }
  }


  ngAfterViewInit() {
    this.ticketService.checkTicketPing(true);
  }

  loadWidgetScript() {
    // tslint:disable-next-line:no-string-literal
    if (!window['SIR']) {
      console.log('widget initialized');
      ((a, b, c, d, e, f, g, h, i) => {
        // tslint:disable-next-line:no-unused-expression
        a[e] || (i = a[e] = () => { (a[e].q = a[e].q || []).push(arguments); },
          i.l = 1 * new Date().getTime(),
          i.o = f,
          g = b.createElement(c),
          h = b.getElementsByTagName(c)[0], g.async = 1,
          g.src = d, g.setAttribute('n', e),
          h.parentNode.insertBefore(g, h)
        );
      })(window, document, 'script', 'https://widgets.sir.sportradar.com/' + this.betRadarClientId + '/widgetloader', 'SIR', {
        theme: false, // using custom theme
        language: this.widgetLanguage
      });

    }
  }
  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  // ngDoCheck() {
    // console.log(13);
    // this.sendIframeSize();
    // setTimeout(() => {
    // }, 200);
    // this.ngZone.run(() => {
    //   console.log('zone ' + document.body.clientHeight);
    //   this.sendIframeSize();
    // });
  // }

  // ngAfterContentChecked() {
  //   console.log('ngAfterContentChecked');
  //   this.sendIframeSize();
  // }

  ngAfterViewChecked() {
    // console.log('ngAfterViewChecked');
    this.sendIframeSize();

  }

  private startHttpRequest() {
    this.http.get('http://localhost:313/api/chart')
    .subscribe(res => {
      console.log(res);
    });
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  sendIframeSize() {
    if (this.documentHeight !== document.body.clientHeight || this.documentWidth !== document.body.clientWidth) {
      this.documentHeight = document.body.clientHeight;
      this.documentWidth = document.body.clientWidth;

      if (this.isStagingOrProd) {
        this.setTicketBarInitial();
      }

      if (this.isStagingOrProd && !this.isMobileView && window.parent) {
        // console.log('height post message ' + this.documentHeight);
        // window.parent.postMessage({ width: this.documentWidth, height: this.documentHeight }, DeployParams.POST_MESSAGE_ADDRESS);
      }
    }
  }

  reloadFrame(reload: boolean = false) {
    const iframe = window.parent.document.getElementById('sportIframe') as HTMLIFrameElement;
    // let tail = 'v=' + Math.round(Math.random() * 10000);
    let tail = 'v=' + new Date().getTime();
    if (iframe) {
      const prefix = iframe.src.includes('?') ? '&' : '?';
      tail = prefix + tail;
      if (!iframe.src.includes('v=')) {
        iframe.src += tail;
        iframe.contentWindow.location.reload();
      } else if (reload){
        const array = iframe.src.split('v=');
        iframe.src = array[0].slice(0, array[0].length - 1) + tail;
        iframe.contentWindow.location.reload();
      }
    } else if (reload) {
      // location.reload();
      window.parent.location.reload();
    }
  }

  switchFromDesktopToMobileAndReverse(){
    setTimeout(() => {
      const mobileView = window.innerWidth < 1025 ? true : false;

      if (mobileView !== this.isMobileView) {
        console.log('reload frame');
        this.reloadFrame(true);
      }
    });

  }

  setVariable(interval) {
    // if (document.getElementById('ticketToggleBar') === null || environment.localDeploy ) { return; }
    if (document.getElementById('ticketToggleBar')) {
      // this.bottomElContent = document.getElementById('ticketToggleBar');

      document.getElementById('ticketToggleBar').classList.add('local');
      document.getElementById('mobileMenu').classList.add('local');
      // if (environment.localDeploy) {
      // }

      this.setTicketBarInitial();

      clearInterval(interval);

    }

    this.heightFromTop = this.viewConfigurations.showBannersDesktop ? 0 :  Number(jQuery('body').css('padding-top').replace('px', '')) ;
    this.heightFromBottom = Number(jQuery('body').css('padding-bottom').replace('px', ''));
  }

  setWindowHeight() {
    if (window.parent) {
      this.parentWindowHeight = window.parent.innerHeight;
      // let filteMenuHeight = 0;
      // if (window.document.getElementById('filterNavigationMenuWrap')){
      //   filteMenuHeight = window.document.getElementById('filterNavigationMenuWrap').offsetHeight;
      // }
      this.windowHeight = this.parentWindowHeight - this.platformHeaderHeight;
    }
  }

  setTicketBarInitial() {
    this.setWindowHeight();
    this.bottomPosition('ticketToggleBar');
    this.bottomPosition('mobileMenu');
  }


  scrollFunction() {
    if (!this.isMobileView) {
      this.bodyScrollTop = jQuery(window.parent).scrollTop();
      // this.bodyScrollTop = window.parent.document.documentElement.scrollTop;

      if (window.document.getElementById('topMenuWrap') && this.topMenuWrapHeight < 80){
        this.topMenuWrapHeight = jQuery('#topMenuWrap').outerHeight(true);
      }
      this.setContentPosition('leftContent');
      this.setContentPosition('centerContent');
      if (document.documentElement.clientWidth > this.platformWinWidth1600) {
        this.setContentPosition('rightContent');
      } else {
        this.bottomPosition('streamingWrap');
      }
      // this.scrollTop = window.parent.scrollY;

      // if (this.isStagingOrProd) {
      //   this.bottomPosition('ticketToggleBar');
      //   this.bottomPosition('mobileMenu');
      //   // this.ticketDetailAndNotificationDialog('ticketDetailWrap');
      //   this.ticketDetailAndNotificationDialog('notificationDialogWrap');
      // }
      this.scrollTop = this.bodyScrollTop;

    }


    // if (this.isMobileView || environment.localDeploy){ return; }

    // // this.scrollTop = window.parent.document.getElementById('container').scrollTop;

    // // if (this.notificationDialogShow){
    // //   this.setDialogPosition();
    // // }
    // // this.setWindowHeight();

    // this.bottomPosition();
    // this.ticketDetailAndNotificationDialog('ticketDetailWrap');
    // this.ticketDetailAndNotificationDialog('notificationDialogWrap');
    // // this.ticketDetailAndNotificationDialog('ticketMainWrap');
  }

  bottomPosition(elId: string) {
    if (document.getElementById(elId) === null || environment.localDeploy) { return; }
    this.bottomElContent = document.getElementById(elId);

    if (this.bottomElContent === undefined || this.isMobileView ) { return; }

    // let headerContainer = 0;
    // if (!environment.localDeploy){
    //   headerContainer = window.parent.document.getElementById('backHeaderContainer').offsetHeight;
    // }

    // this.bottomElContent.style.marginTop = top + 'px';
    if (this.windowHeight + this.bodyScrollTop < this.documentHeight ) {
      let top: number;
      if (elId === 'streamingWrap') {
        top = this.windowHeight - this.bottomElContent.offsetHeight + this.bodyScrollTop - 70;
      } else {
        top = this.windowHeight - this.bottomElContent.offsetHeight + this.bodyScrollTop;
      }
      this.bottomElContent.style.transform = 'translate(0px, ' + top + 'px)';
    } else {
      let top: number;
      if (elId === 'streamingWrap') {
        top = this.documentHeight - this.bottomElContent.offsetHeight - 70;
      } else {
        top = this.documentHeight - this.bottomElContent.offsetHeight;
      }
      this.bottomElContent.style.transform = 'translate(0px, ' + top + 'px)';
    }
  }


  ticketDetailAndNotificationDialog(elId: string) {
    if (document.getElementById(elId) === null || environment.localDeploy) { return; }
    // const ticketDetailWrapNotificationDialogWrap = document.getElementById(elId);
    this.ticketDetailWrapNotificationDialogWrap = document.getElementById(elId);

    if (this.bodyScrollTop + this.ticketDetailWrapNotificationDialogWrap.offsetHeight + this.heightFromBottom + this.heightFromTop >= this.documentHeight) {
      const top = this.documentHeight - this.ticketDetailWrapNotificationDialogWrap.offsetHeight - this.heightFromTop - this.heightFromBottom;
      this.ticketDetailWrapNotificationDialogWrap.style.transform = 'translate(0px, ' + top + 'px)';
    } else {
      const top = this.bodyScrollTop + (this.windowHeight - this.ticketDetailWrapNotificationDialogWrap.offsetHeight) / 2;
      this.ticketDetailWrapNotificationDialogWrap.style.transform = 'translate(0px, ' + top + 'px)';
    }

  }

  // ticketPosition() {
  //   if (document.getElementById('ticketMainWrap') === null) { return; }

  //   this.ticketMainWrap = document.getElementById('ticketMainWrap');
  // }

  ticketDialogResize() {
    setTimeout(() => {
      if (document.getElementById('ticketDetailWrap') === null) { return; }
      const ticketDetailWrap = document.getElementById('ticketDetailWrap');

      if (this.windowHeight < this.documentHeight) {
        ticketDetailWrap.style.maxHeight = this.windowHeight - 30 + 'px';
      } else {
        ticketDetailWrap.style.maxHeight = this.documentHeight - 30 + 'px';
      }

      // if (this.scrollTop + this.windowHeight - 30 < this.documentHeight) {
      //   const move = this.scrollTop + (this.windowHeight - ticketDetailWrap.offsetHeight) / 2;
      //   ticketDetailWrap.style.transform = 'translate(0px, ' + move + 'px)';
      // } else {
      //   const move = this.documentHeight - this.windowHeight;
      //   ticketDetailWrap.style.transform = 'translate(0px, ' + move + 'px)';
      // }

    }, 100);

    const interval = setInterval(() => { this.setVariable(interval); }, 100);
  }

  setContentPosition(elId: string) {
    if (document.getElementById(elId) === null || this.isMobileView ) { return; }
    const elContent = document.getElementById(elId);
    const elContentHeight = elContent.offsetHeight;
    const elementOffsetTop = Math.floor(jQuery('#' + elId).offset().top) - this.heightFromTop;
    // this.bodyScrollTop = this.scrollTop;

    // set elContent to 0, because it could be greater than 0
    if (this.bodyScrollTop - this.topMenuWrapHeight <= 0) {
      elContent.style.transform = 'translate(0px, ' + 0 + 'px)';
      return;
    }

    if (this.bodyScrollTop - this.topMenuWrapHeight >= 0 && document.documentElement.clientWidth > 1024) {

      // if (document.documentElement.clientWidth < 1143) {
      //   if (jQuery('.ticket-scroller-wrap').outerHeight() > document.documentElement.scrollHeight) {
      //     return;
      //   }
      // }

      // if elementID higher then window height
      if (elContentHeight + this.heightFromBottom + this.heightFromTop > this.windowHeight) {
        // if elementID height equal to body height
        if ((elContentHeight + this.heightFromTop + this.heightFromBottom) === this.documentHeight - this.topMenuWrapHeight) {
          elContent.style.transform = 'translate(0px, ' + 0 + 'px)';
          return;
        }

        // scrolling up
        if (this.bodyScrollTop < this.scrollTop) {

          // set elementID sticked to top
          if (this.bodyScrollTop <= elementOffsetTop) {
            const move = this.bodyScrollTop - this.topMenuWrapHeight;
            elContent.style.transform = 'translate(0px, ' + move + 'px)';
          }

        } else {
          // console.log('elId ' + elId);
          // console.log('this.bodyScrollTop ' + this.bodyScrollTop);
          // console.log('this.windowHeight ' + this.windowHeight);
          // console.log('this.documentHeight ' + this.documentHeight);
          // const sss = this.documentHeight - elContentHeight - this.heightFromTop - this.heightFromBottom;
          // console.log('sss ' + sss);
          // // console.log('---- ');
          // console.log('elContentHeight ' + elContentHeight);
          // console.log('this.heightFromTop ' + this.heightFromTop);
          // console.log('this.heightFromBottom ' + this.heightFromBottom);
          // not scroll over footer
          if (this.bodyScrollTop + this.windowHeight >= this.documentHeight) {
            const move = this.documentHeight - elContentHeight - this.heightFromTop - this.heightFromBottom - this.topMenuWrapHeight;
            // console.log('move111 ' + move);
            elContent.style.transform = 'translate(0px, ' + move + 'px)';
          } else {
            // if window height + body scroll higher then elementID offset + elHeight
            // set elementID sticked to bottom
            // console.log('elId ' + elId);
            // const aaa = this.bodyScrollTop + this.windowHeight;
            // const bbb = elementOffsetTop + elContentHeight + this.heightFromBottom + this.heightFromTop;
            // console.log('aaa ' + aaa);
            // console.log('bbb ' + bbb);
            if (this.bodyScrollTop + this.windowHeight >= elementOffsetTop + elContentHeight + this.heightFromBottom + this.heightFromTop) {
              const move = (this.bodyScrollTop - (elContentHeight - this.windowHeight)) - this.heightFromBottom - this.heightFromTop - this.topMenuWrapHeight;
              // console.log('move2222 ' + move);
              elContent.style.transform = 'translate(0px, ' + move + 'px)';
            }

          }

        }

      } else {
        // not scroll over footer
        if (this.bodyScrollTop + elContentHeight + this.heightFromBottom + this.heightFromTop >= this.documentHeight) {
          const move = this.documentHeight - this.topMenuWrapHeight - elContentHeight - this.heightFromTop - this.heightFromBottom;
          // console.log('move333 ' + move);
          elContent.style.transform = 'translate(0px, ' + move + 'px)';

        } else {
          const move = this.bodyScrollTop - this.topMenuWrapHeight;
          // console.log('elId444 ' + elId);
          // console.log('move444 ' + move);
          elContent.style.transform = 'translate(0px, ' + move + 'px)';
        }
      }

    } else {
      if ((elContentHeight + this.heightFromTop + this.heightFromBottom) >= this.documentHeight - this.topMenuWrapHeight) {
        elContent.style.transform = 'translate(0)';
      }
    }

  }

  setScrollTop(elId: string) {
    if (document.getElementById(elId) === null || this.isMobileView || this.topMenuWrapHeight > this.bodyScrollTop) { return; }
    const elContent = document.getElementById(elId);
    const move = this.bodyScrollTop - this.topMenuWrapHeight;
    elContent.style.transform = 'translate(0px, ' + move + 'px)';
  }

  disableParentScroll() {
    window.parent.document.documentElement.style.overflow = 'hidden';
  }

  enableParentScroll() {
    window.parent.document.documentElement.style.overflow = 'auto';
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
